import React from 'react';
import Auth from 'service/auth';

class Protected extends React.Component
{
  constructor(props)
  {
    super(props);
    this.allow = props.allow||[];
    this.when  = true;
    if ('undefined' !== typeof props.when)
      this.when = !!props.when;
  }
  render()
  {
    let allow = (() => {
      if (!this.when)
        return true;
      else if (this.allow === false)
        return false;
      if (this.allow === true)
        return true;
      else if ( Auth.User )
      {
        if (Auth.User.Role === 'SYSTEM') return true;
        if (Array.isArray(this.allow)) return this.allow.indexOf(Auth.User.Role)>=0;
      }
      return false;
    })();

    return !allow?'':<>{this.props.children}</>;
  }
}

export default Protected;